export default __webpack_public_path__ + "static/media/c6.57a02078.svg";